jQuery(document).ready(function($) {

    $('.loader').addClass('loader--loading');

    setTimeout(function(){
       $('.loader').addClass('loader--loaded');
    }, 3500);

/* ====================== INIT WOW ======================  */
  new WOW().init();

/* ====================== MOBILE NAV TOGGLE ======================  */
  $('.header:not(".header--members") .menu-toggle').on("click", function() {
      $(this).toggleClass('menu-toggle--open');
      $('.navigation').toggleClass('navigation--open');
      $('body').toggleClass('navOpen');
      $('html').toggleClass('navOpen');
  })

/* ====================== MEMBERS MOBILE NAV ======================  */
  $('.header--members .menu-toggle').on("click", function() {
      $(this).toggleClass('menu-toggle--open');
      $('.account__sidebar').toggleClass('account__sidebar--active');
      $('body').toggleClass('navOpen');
  })

/* ====================== OUR RATES SNIMATION ======================  */
  $('.our-rates').waypoint(function(direction) {
  	$('.our-rates__images .image:not(:first-of-type)').addClass('active');
  }, { offset: $('.our-rates').height() });

/* ====================== SLIDE OUT MEMBER NAV ======================  */
  $('.link--toggle').on("click", function() {
    $('.account').toggleClass('account--navopen');
    $(this).toggleClass('active');
    $('.account__sidebar').toggleClass('account__sidebar--active');
    $('.account .menu-toggle').toggleClass('menu-toggle--open');
  })

/* ====================== GENERIC TAB SYSTEM ======================  */
  $(".tabs .tabs__link").first().addClass("tabs__link--active");
  $(".tabs-content .tab-content").first().addClass("tab-content--active");

  var uiTabBasic = $(".tabs .tabs__link");
  var uiTabContentBasic = $(".tabs-content .tab-content");

  uiTabBasic.on("click", function() {
    var tab = $(this).attr("data-tab");
    toggleTabBasic(tab);
  })

  var toggleTabBasic = function(tab) {
      uiTabBasic.removeClass('tabs__link--active');
      uiTabContentBasic.removeClass('tab-content--active');
      $('.tabs .tabs__link[data-tab="'+tab+'"]').addClass('tabs__link--active');
      $('.tabs-content .tab-content[data-tab="'+tab+'"]').addClass('tab-content--active');
  }

  $('.tabs-mobile #tabFilter').on('change', function() {
      var tab = $(this).val();

     $('.tabs-content .tab-content').hide().removeClass('tab-content--active');
     $('.tabs-content .tab-content[data-tab="'+tab+'"]').show().addClass('tab-content--active');
  });

/* ====================== RATE TABS TOGGLE ======================  */
  $(".rates .rate-tabs__link").first().addClass("rate-tabs__link--active");
  $(".rates .rate-tabs-content .rate-tab-content").first().addClass("rate-tab-content--active");

  var uiTabRates =  $(".rates .rate-tabs__link");
  var uiTabContentRates = $(".rates .rate-tab-content");

  uiTabRates.on("click", function() {
    var tab = $(this).attr("data-tab");
    toggleTabRates(tab);
  })

  var toggleTabRates = function(tab) {
      uiTabRates.removeClass('rate-tabs__link--active');
      uiTabContentRates.removeClass('rate-tab-content--active');
      var fTable = $('.rates .rate-tab-content[data-tab="'+tab+'"]').find('table');

      fTable.footable({
          "breakpoints": {
            "xs": 480,
            "sm": 768,
            "md": 992,
            "lg": 1200,
            "xl": 1400
          }
      });

      $('.rates .rate-tabs__link[data-tab="'+tab+'"]').addClass('rate-tabs__link--active');
      $('.rates .rate-tab-content[data-tab="'+tab+'"]').addClass('rate-tab-content--active');
  }

  $('.rate-tabs-selct #ratesFilter').on('change', function() {
      var tab = $(this).val();
     $('.rates .rate-tab-content').hide().removeClass('rate-tab-content--active');
     $('.rates .rate-tab-content[data-tab="'+tab+'"]').show().addClass('rate-tab-content--active');
  });

/* ====================== RATE TABS TOGGLE ======================  */
  $('.table').footable({
      "breakpoints": {
        "xs": 480,
        "sm": 768,
        "md": 992,
        "lg": 1200,
        "xl": 1400
      }
  });

  $('.faq-strip:not(.faq-strip--basic) .faq-strip__heading').on("click", function() {
    $(this).parent().find('.faq-strip__content').slideToggle();
    $(this).closest('.faq-strip').toggleClass('faq-strip--active')
  })

  function form_stick() {
      if($(window).width() > 992) {
        $(".update-wrap").stick_in_parent({
            offset_top: 30
        });
      }
  }

  function mobile_menu() {
    var checkWidth = $(window).width();
    if (checkWidth < 992) {
      /* ====================== Mobile Menu accordion ======================  */
      $(".nav  li.menu-item-has-children").on("click", function(event) {
        console.log('clicked');
        $(this).find('> a').toggleClass('active');
        $(this).find('.sub-menu').slideToggle();
      });
    }
  }

  /* ====================== GENERIC TAB SYSTEM ======================  */
  $(".contact-tabs .contact-tabs__link").first().addClass("contact-tabs__link--active");
  $(".contact-tabs-content .contact-tab-content").first().addClass("contact-tab-content--active");
  $('.contact-tabs-content .contact-tab-content:first').find('.contacts-table').first().addClass('contacts-table--active');

  var uiContactTab =  $(".contact-tabs .contact-tabs__link");
  var uiContactTabContent = $(".contact-tabs-content .contact-tab-content");

  uiContactTab.on("click", function() {
    var tab = $(this).attr("data-tab");
    toggleTabContacts(tab);
  })

  var toggleTabContacts = function(tab) {
      uiContactTab.removeClass('contact-tabs__link--active');
      uiContactTabContent.removeClass('contact-tab-content--active');
      $('.contact-tabs-content .contact-tab-content .contacts-table').removeClass('contacts-table--active');

      $('.contact-tabs .contact-tabs__link[data-tab="'+tab+'"]').addClass('contact-tabs__link--active');
      $('.contact-tabs-content .contact-tab-content[data-tab="'+tab+'"]').addClass('contact-tab-content--active');
      $('.contact-tabs-content .contact-tab-content[data-tab="'+tab+'"] .contacts-table').first().addClass('contacts-table--active');
  }

  $('.contact-tabs-selct #contactsFilter').on('change', function() {
    var tab = $(this).val();
   $('.contact-tabs-content .contact-tab-content .contacts-table').removeClass('contacts-table--active');
   $('.contact-tabs-content .contact-tab-content .contacts-table[data-table="'+tab+'"]').addClass('contacts-table--active');
  });

  /* ====================== ON SCROLL ======================  */
  $(window).scroll(function() {
      var scroll = $(this).scrollTop();

      if (scroll < 82) {
        $(".account__sidebar").css('top', 82 - scroll + "px");
      } else {
         $(".account__sidebar").css('top', "0px");
      }
  });


  $("#document-filter").on("change", function() {
    var value = this.value;
    var download = $('.downloads-table__row');
    var selector = "[data-category~='" + value + "']";

    if(value=='') {
      download.addClass('downloads-table__row--active');
    } else {
      download.removeClass('downloads-table__row--active');
      $('.downloads-table__body .downloads-table__row').filter(selector).addClass('downloads-table__row--active');
    }
  });

  /* ====================== Enable functions on page load ======================  */
    form_stick();
    mobile_menu();

  /* ====================== Resize run functions ======================  */
  $(window).resize(function(){
      form_stick();
      mobile_menu();
  })
});
